import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { Amplify } from 'aws-amplify';
import config from './config';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

if (config.stage === 'prod' && config.posthogKey) {
  posthog.init(config.posthogKey, {
    api_host: config.posthogHost,
    capture_pageview: false, // We handle pageviews manually via React Router
  });
}

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.userPoolId,
      userPoolClientId: config.userPoolClientId,
      loginWith: {
        email: true,
      },
    },
  },
  API: {
    REST: {
      TrackBibleAPI: {
        endpoint: config.apiUrl,
        region: config.region,
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
